import React from "react";
import { Navigate } from "react-router-dom";
import { useHasPermission } from "../../hooks/useHasPermission";

export function RequirePermission({ code, children }: { code: string; children: React.ReactNode }) {
  return useHasPermission(code) ? <>{children}</> : <Navigate to="/" replace />;
}
